import React, { useState } from "react";
import { useLang } from "../LanguageContext";

export default function Menu() {
  const { t } = useLang();
  const [activeKey, setActiveKey] = useState(t.menu.categories[0].key);
  const active = t.menu.categories.find((c) => c.key === activeKey) || t.menu.categories[0];

  return (
    <section
      id="menu"
      data-testid="menu-section"
      className="relative bg-[#F5F2EC] text-[#23211E] py-24 md:py-40 px-6 md:px-10"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-12 gap-8 md:gap-12 mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-5 reveal-on-scroll">
            <p className="text-[11px] uppercase tracking-[0.35em] text-[#565F41] mb-6">
              {t.menu.eyebrow}
            </p>
            <h2 className="font-serif text-4xl md:text-6xl leading-[0.95] tracking-tight">
              {t.menu.title}
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 flex items-end reveal-on-scroll">
            <p className="text-base md:text-lg font-light leading-relaxed text-[#3D3A35] max-w-lg">
              {t.menu.intro}
            </p>
          </div>
        </div>

        {/* Category tabs */}
        <div
          data-testid="menu-categories"
          className="flex flex-wrap gap-x-8 gap-y-3 border-y border-[#23211E]/15 py-5 mb-14"
        >
          {t.menu.categories.map((cat) => (
            <button
              key={cat.key}
              data-testid={`menu-tab-${cat.key}`}
              onClick={() => setActiveKey(cat.key)}
              className={`text-[11px] md:text-xs uppercase tracking-[0.28em] py-2 transition-all border-b ${
                activeKey === cat.key
                  ? "text-[#B85532] border-[#B85532]"
                  : "text-[#23211E] border-transparent hover:text-[#B85532]"
              }`}
            >
              {cat.title}
            </button>
          ))}
        </div>

        {/* Active category items */}
        <div
          key={active.key}
          data-testid={`menu-section-${active.key}`}
          className="grid grid-cols-12 gap-8 md:gap-12 fade-swap"
        >
          <div className="col-span-12 md:col-span-4">
            <h3 className="font-serif text-3xl md:text-5xl leading-tight">
              {active.title}
            </h3>
            {active.price && (
              <p
                data-testid={`menu-price-${active.key}`}
                className="mt-3 font-serif italic text-xl md:text-2xl text-[#B85532]"
              >
                {active.price}
              </p>
            )}
            <span className="block mt-4 h-px w-16 bg-[#B85532]" />
          </div>
          <ul className="col-span-12 md:col-span-8 space-y-8">
            {active.items.map((item, idx) => (
              <li
                key={idx}
                data-testid={`menu-item-${active.key}-${idx}`}
                className="grid grid-cols-12 gap-4 items-baseline border-b border-[#23211E]/10 pb-6"
              >
                <span className="col-span-1 font-serif italic text-sm text-[#565F41] pt-1">
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <div className="col-span-11">
                  <div className="flex items-baseline justify-between gap-4">
                    <h4 className="font-serif text-xl md:text-2xl leading-snug">
                      {item.name}
                    </h4>
                    {item.price && (
                      <span
                        data-testid={`menu-item-price-${active.key}-${idx}`}
                        className="font-serif text-lg md:text-xl text-[#B85532] whitespace-nowrap"
                      >
                        {item.price}
                      </span>
                    )}
                  </div>
                  {item.desc && (
                    <p className="mt-1.5 text-sm md:text-base font-light text-[#3D3A35] leading-relaxed">
                      {item.desc}
                    </p>
                  )}
                </div>
              </li>
            ))}
            {active.footer && (
              <li className="text-sm italic text-[#565F41] pt-2">
                {active.footer}
              </li>
            )}
          </ul>
        </div>
      </div>
    </section>
  );
}
